import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import iconKeyEnter from "assets/img/icon-key-enter.svg"

import { Flex } from "components/Flex"

interface ISelectCreateLabel {
    search: string
    testId?: string
}

const SelectCreateLabel: FunctionComponent<React.PropsWithChildren<ISelectCreateLabel>> = ({
    search,
    testId,
}) => {
    const { t } = useTranslation()
    return (
        <Flex
            alignItems="center"
            data-testid={testId}>
            <span>{t('common.add')} <strong>{search}</strong></span>
            <img src={iconKeyEnter} alt="" className="pl-1" />
        </Flex>
    )
}

export default SelectCreateLabel
